module.exports = __webpack_public_path__ + "img/slideset_active.81f38dac.svg";